import MultiSelectDropdown from '../../Controls/multiselectdropdown';
import '../../../assets/Styles/DispatchCSS/DispatchCSS.css';
import React, { useState, useRef } from "react";
import { useSelector } from "react-redux";
import {Col, Container, Modal, Row, Button, Spinner }from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import APICom from '../../../utils/helpers/APICom';
import AlertBox from '../../common/alert';
const PenaltyForm = (props) => {
    const { loginData } = useSelector((store) => store.login);
    const penaltyReasonRef = useRef();
    const penStartRef = useRef();
    const penStartTimeRef = useRef();
    const penMilesRef = useRef();
    const penHoursRef = useRef();
    const [showAlert, setShowAlert] = useState(false);
    const [title, setTitle] = useState("-1");
    const [body, setBody] = useState("-1");

    let penaltyStr = "Previous Penalty Expired!";
    {props.penHrsLeft > 0 ? penaltyStr = "Penalty Hours Left = " + props.penHrsLeft : penaltyStr = "Previous Penalty Expired!"}
    const handleOk = () => {
        
        if (penHoursRef.current.value === '' || parseFloat(penHoursRef.current.value)=== 0 || parseFloat(penHoursRef.current.value) <= 0) {
            setTitle('Hours Missing');
            setBody('Hours cannot be null or zero. please Select the Hours..');
            setShowAlert(true);
          } else {
            // A column is selected, hide the alert
            SavePenalty();
            

          }
        // SavePenalty();
    };
    const handleRemove = () => {
    
        RemovePenalty();
    };



    const SavePenalty = async () => {
        let d =new Date(penStartRef.current.value+" "+penStartTimeRef.current.value)
        var Param = {
          "dtPenStart": d.toISOString(),
          "vPenReason": penaltyReasonRef.current.value,
          "penMileage": parseFloat(penMilesRef.current.value),
          "penHours": parseFloat(penHoursRef.current.value),
          "iCreatedByUID": parseInt(loginData.iUserID),
          "iModifiedByUID": parseInt(loginData.iUserID),
          "iDriverID": parseInt(props.driverId),
          "iVehicleID": -1,
          "iModifiedByAppID": 5,
          "bUpdateDriver": 1,
          "iRejectedServiceID": -1,
          "iCreatedByAppID": 5
        }

        let response = await APICom.fetchData("", "DispatchActions/saveDriverPenalty", "post", { "Content-Type": "application/json" }, Param, null);
        let result = response.data;

        if(result === "200")
        {
            
            setTitle('Success');
            setBody('Driver Penalty Saved Successfully!!');
            setShowAlert(true);
            //props.setShowPenaltyForm(false);
        }
        else
        {
            setTitle('Failure');
            setBody('Penalty Could Not Saved!!!');
            setShowAlert(true);
        }
    }

    const RemovePenalty = async () => {
        let d =new Date(penStartRef.current.value+" "+penStartTimeRef.current.value)
        var Param = {
          "dtPenStart": d.toISOString(),
          "vPenReason": "",
          "penMileage": parseFloat(penMilesRef.current.value),
          "penHours": parseFloat(0),
          "iCreatedByUID": parseInt(loginData.iUserID),
          "iModifiedByUID": parseInt(loginData.iUserID),
          "iDriverID": parseInt(props.driverId),
          "iVehicleID": -1,
          "iModifiedByAppID": 5,
          "bUpdateDriver": 1,
          "iRejectedServiceID": -1,
          "iCreatedByAppID": 5
        }

        let response = await APICom.fetchData("", "DispatchActions/saveDriverPenalty", "post", { "Content-Type": "application/json" }, Param, null);
        let result = response.data;
        console.log(result);
        if(result === "200")
        {
            
            setTitle('Sucess');
            setBody('Driver Penalty Remove Successfully!!');
            setShowAlert(true);
            // props.setShowPenaltyForm(false);
        }
        else
        {
            setTitle('Failure');
            setBody('Penalty Could Not Removed!!');
            setShowAlert(true);
        }
    }

    const handleCancel = () => {
        props.setShowPenaltyForm(false);
    };

    const handleCloseDriverPenaltyForm = () => {
        if(props.showPenaltyForm)
        {
            props.setShowPenaltyForm(false);
        }
    }
    return(
     <>
        <Modal show={props.showPenaltyForm ? 1:0} centered animation={true} onHide={handleCloseDriverPenaltyForm} backdrop="static" keyboard={true} size="lg" 
        aria-labelledby="contained-modal-title-vcenter">
            <Modal.Header className='activate_dialog_header_bgcolor' closeButton>
                <Modal.Title id="contained-modal-title-vcenter" className='activate_dialog_title_color'>
                    Penalty Form
                </Modal.Title>
            </Modal.Header>
                <Modal.Body className="grid-example">

                    <Row className="tripaction_btn_seperator"></Row>
                    <Row>
                        <Col xs={6} md={2}>

                        </Col>
                        <Col xs={6} md={4}>
                            <span>{penaltyStr}</span>
                        </Col>
                    </Row>

                    <Row className="tripaction_btn_seperator"></Row>
                    <Row>
                        <Col xs={6} md={6}>
                            Penalty Start: &nbsp;&nbsp;<input type="Date" defaultValue={props.penStrt} ref={penStartRef} className="PenaltyDate"/> <input type="time" className="PenaltyTime" ref={penStartTimeRef} defaultValue={props.penTime}/>
                        </Col>
                        <Col xs={6} md={6}>
                            PEN. Mileage: <input type="text" className="PenMiles" ref={penMilesRef} defaultValue={props.penMile}/>
                        </Col>
                    </Row>
                    <Row className="tripaction_btn_seperator"></Row>
                    <Row>
                        <Col xs={6} md={6}>
                            Penalty Reason:&nbsp;  <textarea rows="2" cols="23" defaultValue={props.penRsn} ref={penaltyReasonRef}></textarea> 
                        </Col>
                        <Col xs={6} md={6}>
                            PEN. Hours: &nbsp;&nbsp; <input type="text"  className="PenHour" ref={penHoursRef} defaultValue={props.penHrs}/>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleOk}>
                        Save
                    </Button>
                    <Button variant="primary" onClick={handleRemove}>
                        Remove Penalty
                    </Button>
                    <Button variant="secondary" onClick={handleCancel}>
                        Cancel
                    </Button>
                    
                </Modal.Footer>
        </Modal> 
        {showAlert ? <AlertBox showAlert={showAlert} setShowAlert={setShowAlert} title={title} body={body} />: ""}
            
        {/*{irtpuComponentLoaded ? <IRTPU GridRowData={props.GridRowData} irtpuComponentLoaded={irtpuComponentLoaded} setIRTPUComponentLoad={setIRTPUComponentLoad} setIsProcessing={setIsProcessing}  /> : "" }*/}
     </>
    );
}

export default PenaltyForm